import { Form, Formik } from 'formik';
import moment from 'moment';
import React, { memo, useCallback } from 'react';
import { useWebHookHistoric } from 'v2/components/Pages/Webhook/context';

import type { IWebHookFilterHistoric } from 'v2/interfaces/webhook/historic';

import Fields from './Fields';
import styles from './styles';
import { filterHistoricSchema } from './validations';

import type { FormikProps } from 'formik';

export const initialValuesWebhookHistoric: IWebHookFilterHistoric = {
  invoice: '',
  product: [],
  customer: '',
  url: '',
  date: [moment().subtract(7, 'days').format('DD/MM/YYYY'), moment().format('DD/MM/YYYY')],
  type: 'invoice',
};

const Filters = memo(() => {
  const classes = styles();
  const { setFiltersHistoric } = useWebHookHistoric();

  const onSubmit = useCallback(
    (values: IWebHookFilterHistoric, { setSubmitting }: FormikProps<IWebHookFilterHistoric>) => {
      for (let v in values) {
        if (!values[v] || values[v] === null || values[v] === '') {
          delete values[v];
        }
      }

      setFiltersHistoric(values);
      setSubmitting(false);
    },
    [setFiltersHistoric]
  );

  return (
    <div className={classes.filters}>
      <Formik initialValues={initialValuesWebhookHistoric} validationSchema={filterHistoricSchema} onSubmit={onSubmit}>
        {() => (
          <Form>
            <Fields />
          </Form>
        )}
      </Formik>
    </div>
  );
});

export default Filters;
